export const GET_CLIENTS_SUCCEED = 'Clients/GET_SUCCEEDED';
export const GET_CLIENTS_ERROR = 'Clients/GET_ERROR';
export const INVITE_CLIENT_SUCCEED = 'Clients/INVITE_SUCCEEDED';
export const INVITE_CLIENT_ERROR = 'Clients/INVITE_ERROR';
export const CLEAR_CLIENT_STATE = 'Clients/CLEAR_CLIENT_STATE';
export const GET_CLIENTS_LOADING_STATE = 'Clients/GET_CLIENTS_LOADING_STATE';
